import { useHistory } from "react-router-dom";
import { useLocalStorage } from "./useLocalStorage";
import { useUserId } from "../../query/hooks/helpers";

type HistoryCheckpoint = {
  [key: string]: {
    path: string;
    state?: any;
  };
};

export const useHistoryCheckpoint = (key: string) => {
  const history = useHistory();
  const userId = useUserId();
  const [storage, setStorage] = useLocalStorage<HistoryCheckpoint>(
    `history-checkpoint-${userId}`,
    {},
    "session"
  );

  return {
    saveCheckpoint() {
      setStorage(prev => ({
        ...prev,
        [key]: {
          path: history.location.pathname,
          state: history.location.state
        }
      }));
    },
    isCheckpointSaved() {
      return !!storage[key];
    },
    goToCheckpoint() {
      const storageData = storage[key];

      setStorage(prev => {
        const { [key]: _, ...rest } = prev;
        return rest;
      });

      if (storageData && storageData.path === history.location.pathname) {
        history.replace(storageData.path, storageData.state);
        return true;
      } else if (storageData) {
        history.push(storageData.path, storageData.state);
        return true;
      }

      return false;
    },
    getCheckpointData() {
      return storage[key];
    },
    resetCheckpoint() {
      setStorage(prev => {
        const { [key]: _, ...rest } = prev;
        return rest;
      });
    }
  };
};
